import BasicTextInput from "components/BasicInputs/BasicTextInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import SwitchableTextInput from "../../BasicInputs/SwitchableTextInput";
import {useDispatch, useSelector} from "react-redux";
import {apiGetWarehouses} from "api/warehouseApi";
import {useContext, useEffect, useState} from "react";
import {apiGetProjects} from "api/projectApi";
import {apiGetBranches} from "api/branchApi";
import {DateToString} from "components/Reports/DateFilter";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import {STContext} from ".";

export interface StockTackingFormData {
    warehouseId?: number;
    description?: string | number;
    operator?: string | number;
    accountingCode?: string | number | null;
    date?: string;
    projectId?: number;
    branchId?: number;
    status: "during" | "finished";
}

export interface FormProps {
    onChange?: (fd: StockTackingFormData) => void;
}

const initialFormData: StockTackingFormData = {
    date: DateToString(Date.now()),
    status: "finished",
};

export default function Form({onChange}: FormProps) {
    const dispatch = useDispatch();
    const {token} = useSelector((state: any) => state).businessReducer.business;
    const {warehouses} = useSelector((state: any) => state).warehouseReducer;
    const {projects} = useSelector((state: any) => state).projectReducer;
    const {branches} = useSelector((state: any) => state).branchReducer;
    const [formData, setFormData] = useState<StockTackingFormData>(initialFormData);

    const data = useContext(STContext);

    // useEffect(() => {
    //   dispatch(apiGetWarehouses(token));
    //   dispatch(apiGetProjects(token));
    //   dispatch(apiGetBranches(token));
    // }, [token]);

    useEffect(() => onChange && onChange(formData), [formData]);
    useEffect(() => {
        if (!data) return;
        const fd: StockTackingFormData = {
            accountingCode: data.accountingCode,
            branchId: data.BranchId,
            projectId: data.ProjectId,
            date: data.date,
            description: data.description,
            operator: data.operator,
            warehouseId: data.WarehouseId,
            status: data.status,
        };
        setFormData(fd);
    }, [data]);

    return (
        <div style={{backgroundColor: "#ffffff", borderRadius: 6}}>
            <div id="header" style={{padding: "12px 24px", borderBottom: "1px solid #F6F7FA"}}>
                <span style={{fontSize: 16}}>مشخصات</span>
            </div>
            <div className="p-2 md:p-6 flex justify-between gap-10">
                <div className="flex flex-col gap-10 w-full md:w-auto md:min-w-[300px]">
                    <BasicSelect
                        label="انبار"
                        options={warehouses}
                        defaultValue={formData.warehouseId}
                        onChange={(val) => setFormData((x) => ({...x, warehouseId: val}))}
                        required
                        withRefresh
                        // @ts-ignore
                        refreshList={() => dispatch(apiGetWarehouses(token))}
                    />
                    <BasicTextInput
                        label="توضیحات"
                        onChange={(val) => setFormData((x) => ({...x, description: val}))}
                        val={formData.description}
                        required
                    />
                    <BasicTextInput
                        label="متصدی"
                        onChange={(val) => setFormData((x) => ({...x, operator: val}))}
                        val={formData.operator}
                        required
                    />
                </div>
                <div className="flex flex-col gap-10 w-full md:w-auto md:min-w-[300px]">
                    <SwitchableTextInput
                        label="کد حسابداری"
                        onChange={(val) => setFormData((x) => ({...x, accountingCode: val || null}))}
                        val={formData.accountingCode || ""}
                    />
                    <BasicDateInput
                        label="تاریخ"
                        withoutClear
                        onChange={(dates) => dates && setFormData((x) => ({...x, date: dates[0]}))}
                        defaultValues={formData.date ? [formData.date] : undefined}
                        required
                    />

                    <div style={{display: "flex", gap: 10}}>
                        <BasicSelect
                            label="پروژه"
                            options={projects}
                            onChange={(val) => setFormData((x) => ({...x, projectId: val}))}
                            defaultValue={formData.projectId}
                            withRefresh
                            // @ts-ignore
                            refreshList={() => dispatch(apiGetProjects(token))}
                        />
                        <BasicSelect
                            label="شعبه"
                            options={branches}
                            defaultValue={formData.branchId}
                            onChange={(val) => setFormData((x) => ({...x, branchId: val}))}
                            withRefresh
                            // @ts-ignore
                            refreshList={() => dispatch(apiGetBranches(token))}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
